import { Box, OutlinedInput } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Images } from "../../assets/common";
import cookieStorage from "../../services/cookie-storage";
import {
  formatedDate,
  getUserDetail,
  getUserId,
  truncate,
} from "./../../constants/function";
import { SocketContext } from "./../../context/socket";

import "./index.scss";
export default function ChatInput(props) {
  const [status, setStatus] = useState();
  const token = cookieStorage.getCookie("Authorization");
  const [loading, setLoading] = React.useState(false);
  const socket = useContext(SocketContext).Socket;

  const [message, setMessage] = React.useState("");
  const sendMessage = () => {
    if (message.trim() !== "") {
      const userData = getUserDetail();
      const senderId = props["senderUserId"] || userData["_id"] || getUserId();
      const clientMessageId = `${userData["_id"]}-${Date.now()}`;
      const payload = {
        roomId:
          props["roomId"] && props["type"] === "direct"
            ? props["roomId"]
            : props["playListId"],
        senderUserId: senderId,
        message: message,
        _id: userData["_id"],
        JWT: token,
        isOpened: false,
        clientMessageId,
        createdAt: new Date().toISOString(),
      };
      setMessage("");
      if (props["type"] === "direct") socket.emit("send", payload);
      else socket.emit("chat_message", payload);

      const optimisticMessage = {
        ...payload,
        _id: clientMessageId,
        user: {
        firstName: userData["firstName"],
        lastName: userData["lastName"],
        profileImg: userData["profileImg"],
        _id: userData["_id"],
        },
        createdAt: new Date(),
        isLocal: true,
        senderUserId: senderId,
      };

      props.onSendMessage(optimisticMessage);
      document.getElementById("_chat_box").focus();
    }
  };
  const handleEnterPress = (event) => {
    if (event.shiftKey && event.keyCode === 13) return;
    else if (event.keyCode === 13) {
      sendMessage();
    }
  };

  const onKeyup = (event) => {
    setMessage(event.target.value);
    if (event.keyCode === 13) {
      handleEnterPress(event);
    }
  };

  useEffect(() => {
    if (props["message"].length) {
      setMessage((prevMsg) => prevMsg + props["message"]);
      if (props.cleanEmoji()) props.cleanEmoji();
    }
  }, [props["message"]]);
  useEffect(() => {
    if (props.status) setStatus(props.status);
    // console.log(status);
  }, [props.status]);
  return (
    <Box
      sx={{
        display: "flex",
        width: "inherit",
        height: "80%",
        paddingBottom: "10px",
      }}
    >
      <textarea
        id="_chat_box"
        rows="2"
        title={"Type message"}
        autoFocus
        className="__chat_input rounded-md"
        type="text"
        value={message}
        style={{
          width: "100%",
          backgroundColor: "#1a1a1a",
          borderRadius: "30px",
          color: "#fff",
          fontSize: "15px",
          outline: "none",
          resize: "none",
          padding: "10px 14px",
          boxSizing: "border-box",
        }}
        placeholder="Type your message"
        onChange={(e) => {
          // socket.emit("typing", "");
          setMessage(e.target.value);

          // setShowUsers(false);
          // setOpenTip(false);
        }}
        onKeyUp={(e) => onKeyup(e)}
      />
      <img
        aria-label="send message"
        title={"send message"}
        className="__sent_botton"
        onClick={() => sendMessage()}
        src={message.trim() === "" ? Images.send : Images.send_active}
        alt="send"
      />
    </Box>
  );
}
